<script setup>
import BackgroundSection from "./BackgroundSection.vue";
import SmoothScrollLink from "./SmoothScrollLink.vue";
import content from "../content.js";

const hero = content.hero;
</script>

<template>
    <BackgroundSection
        section-id="hero"
        :video="hero.video"
        :image="hero.image"
        overlay-class="bg-black/40"
        extra-class="text-center"
    >
        <div class="px-4">
            <h1
                class="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold mb-4 sm:mb-6 text-shadow"
                data-aos="fade-up"
            >
                {{ hero.title }}
            </h1>
            <p
                class="text-sm sm:text-lg md:text-xl lg:text-2xl mb-6 sm:mb-8 text-shadow"
                data-aos="fade-up"
                data-aos-delay="200"
            >
                {{ hero.subtitle }}
            </p>
            <div
                class="flex flex-wrap justify-center gap-4"
                data-aos="zoom-in"
                data-aos-delay="400"
            >
                <SmoothScrollLink
                    target="#projects"
                    class="min-w-[160px] text-center px-6 py-3 bg-white/20 backdrop-blur-md border border-white/30 rounded-full text-white font-medium shadow-lg hover:bg-white/30 hover:shadow-xl hover:scale-105 transform transition-all duration-300 text-sm sm:text-base"
                >
                    Our Projects
                </SmoothScrollLink>
                <SmoothScrollLink
                    target="#investment"
                    class="min-w-[160px] text-center px-6 py-3 bg-white/20 backdrop-blur-md border border-white/30 rounded-full text-white font-medium shadow-lg hover:bg-white/30 hover:shadow-xl hover:scale-105 transform transition-all duration-300 text-sm sm:text-base"
                >
                    Invest Us
                </SmoothScrollLink>
            </div>
        </div>
    </BackgroundSection>
</template>
